import React, { useEffect, useState } from 'react'
import { FaPlusCircle, FaRegTimesCircle } from 'react-icons/fa'
import { IconButton } from '@material-ui/core'
import { useQuery } from '@apollo/client'

import BaseBin from '../BaseBin'
import CreateForm from './Forms/Create'
import Environment from './Displays/Environment'
import styles from './environment.module.scss'
import { Q_ENVIRONMENT } from 'graphql/query'
import Loading from 'components/Global/Loading'
import NoContents from 'components/Global/NoContents'

const EnvironmentBin = () => {
  const [create, setCreate] = useState(false)
  const [data, setData] = useState()
  const [loading, setLoading] = useState(true)
  const [noContents, setNoContents] = React.useState(false)

  const { refetch } = useQuery(Q_ENVIRONMENT)

  const update = () => {
    refetch() &&
      refetch()
        .then(res => {
          setData(res.data.getEnvironment)
          setLoading(false)
        })
        .catch(err => {
          console.error(err)
          setNoContents(true)
        })
  }
  useEffect(() => {
    update()
  }, [])
  return noContents ? (
    <NoContents />
  ) : !loading ? (
    <div>
      <BaseBin
        title="Environment"
        actions={[
          <IconButton
            className={styles.icnButton}
            color="primary"
            onClick={() => setCreate(i => !i)}
          >
            {!create ? <FaPlusCircle /> : <FaRegTimesCircle />}
          </IconButton>,
        ]}
      >
        {!create ? (
          <Environment data={data} loading={setLoading} update={update} />
        ) : (
          <CreateForm
            setCreate={setCreate}
            update={update}
            loading={setLoading}
          />
        )}
      </BaseBin>
    </div>
  ) : (
    <Loading />
  )
}

export default EnvironmentBin
